<template>
  <el-container>
    <el-main id="googleMap" ref="googleMap">
      <el-row>
        <el-col>
          <template
            v-if="
              Boolean(this.loader) && Boolean(this.map) && Boolean(this.google)
            "
          >
            <slot :loader="loader" :map="map" :google="google"></slot>
          </template>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
  import { Loader } from '@googlemaps/js-api-loader'

  export default {
    props: {
      mapConfig: Object,
      apiKey: String
    },

    data() {
      return {
        map: null,
        loader: null,
        google: null
      }
    },

    async mounted() {
      console.log('map loader api key:', this.apiKey)
      this.loader = new Loader({
        apiKey: this.apiKey,
        version: 'weekly',
        libraries: ['places, drawing'],
        language: 'es',
        region: 'CO',
        mapId: 'cybersiap_map_1'
      })

      this.loader
        .importLibrary('maps')
        .then(google => {
          console.log('Google loaded:', google)
          const mapContainer = document.getElementById('googleMap')
          // const mapContainer = this.$refs.googleMap
          this.google = google
          this.map = new this.google.Map(mapContainer, this.mapConfig)
          this.map.setOptions({ styles: this.mapConfig.styles })
        })
        .catch(error => {
          console.log('Map load error:', error)
        })
    },

    methods: {
      initializeMap({ Map }) {
        console.log('initializeMap')
        // const mapContainer = this.$refs.googleMap
        const mapContainer = document.getElementById('googleMap')
        this.map = new Map(mapContainer, this.mapConfig)
      },
      showMoreDetails() {
        console.log('showMoreDetails Loader')
      }
    }
  }
</script>
<style>
  #googleMap {
    height: 600px;
    width: 400px;
  }
  /* Estilo para el contenedor de la leyenda */
  .legend {
    background: #555555;
    padding: 5px;
    margin: 5px;
    font-size: 12px; /* Tamaño de fuente reducido */
    font-family: Arial, sans-serif;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-wrap: wrap;
    max-width: 300px; /* Ancho máximo reducido */
    color: white; /* Texto en color blanco */
  }
  .legend .title {
    font-weight: bold;
    width: 100%;
    margin-bottom: 5px;
    text-align: center; /* Centrar el título */
  }
  .legend .item {
    width: 50%;
    display: flex;
    align-items: center;
    margin-bottom: 3px; /* Reducir margen entre elementos */
    justify-content: flex-start; /* Alinear elementos a la izquierda */
  }
  .legend .item img {
    width: 16px; /* Icono más pequeño */
    height: 16px;
    margin-right: 5px;
    transition: transform 0.3s; /* Añadir transición para el efecto de zoom */
  }
  .legend .item img:hover {
    transform: scale(
      2.0
    ); /* Aumentar el tamaño de la imagen al pasar el mouse */
  }
</style>
